import giftCard from '../images/davanu-karte.png';
import Reveal from '../components/Reveal';
import './GiftCard.css';

export default function GiftCard() {
  return (
    <section id="davanu-karte" className="section giftcard">
      <div className="container giftcard__inner">
        <Reveal className="giftcard__intro">
          <p className="eyebrow">Dāvana</p>
          <h2 className="section-title">Dāvanu karte</h2>
          <p className="lead">Uzdāvini mīļajam cilvēkam atpūtas un labsajūtas brīdi.</p>
        </Reveal>

        <Reveal className="giftcard__media">
          <div className="giftcard__float">
            <div className="giftcard__card">
              <img src={giftCard} alt="Salons Siluets dāvanu karte" />
              <span className="giftcard__shine" aria-hidden="true" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
